/* Upside: product card variant dropdown. A native <select> paints its closed label in one colour,
   so the label is drawn by an overlay: grey text, only "(Save 15%)" in red. Works on Liquid cards
   (home page sections) and Globo cards (collection pages, re-rendered client-side). */
(function () {
  var SEL = 'form select.price-superscript';
  var SAVE = /^(.*?)\s*\(\s*(Save\s[^)]*?)\s*\)\s*$/;

  var css = document.createElement('style');
  css.textContent =
    '.ud-sel{display:block;position:relative;width:100%}' +
    '.ud-sel>select{color:transparent!important}' +
    '.ud-sel>select option{color:#555}' +
    '.ud-sel__txt{position:absolute;pointer-events:none;display:flex;align-items:center;justify-content:center;' +
    'box-sizing:border-box;white-space:nowrap;overflow:hidden;color:#555}' +
    '.ud-sel__txt>span{overflow:hidden;text-overflow:ellipsis}' +
    '.ud-sel__save{color:var(--colorTextSavings,#ba4444);margin-left:.3em;flex:none}' +
    '.ud-sel-list{position:absolute;z-index:2147483000;margin:0;padding:2px 0;list-style:none;background:#fff;' +
    'border:1px solid #37446e;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);box-sizing:border-box}' +
    '.ud-sel-list li{padding:6px 8px;text-align:center;color:#555;cursor:pointer;white-space:nowrap;line-height:1.3}' +
    '.ud-sel-list li:hover,.ud-sel-list li.is-active{background:#eef0f6}' +
    '.ud-sel-list li.is-selected{font-weight:600}' +
    '.ud-sel-list li.is-disabled{color:#b0b0b0;cursor:default;background:none}' +
    '.ud-sel-list li.is-disabled .ud-sel__save{color:#b0b0b0}';
  document.head.appendChild(css);

  // Split "12 Pack - $42.49 (Save 15%)" into the label and the red saving.
  function parts(text) {
    text = text.replace(/\s+/g, ' ').trim();
    var m = text.match(SAVE);
    return m ? [m[1], '(' + m[2].replace(/\s+%/, '%') + ')'] : [text, ''];
  }

  function fill(el, text) {
    var p = parts(text);
    var main = document.createElement('span');
    main.textContent = p[0];
    el.appendChild(main);
    if (p[1]) {
      var s = document.createElement('span');
      s.className = 'ud-sel__save';
      s.textContent = p[1];
      el.appendChild(s);
    }
  }

  // Desktop mouse only: the native list can't show two colours, so open our own list instead.
  // Touch keeps the phone's native picker; keyboard keeps the native select.
  var openList = null;
  function closeList() {
    if (!openList) return;
    openList.remove();
    openList = null;
    document.removeEventListener('pointerdown', outside, true);
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('scroll', closeList, true);
    window.removeEventListener('resize', closeList);
  }
  function outside(e) {
    if (openList && !openList.contains(e.target) && e.target !== openList._sel) closeList();
  }
  function onKey(e) { if (e.key === 'Escape') closeList(); }

  function showList(sel) {
    closeList();
    var r = sel.getBoundingClientRect();
    var ul = document.createElement('ul');
    ul.className = 'ud-sel-list';
    ul.setAttribute('role', 'listbox');
    ul._sel = sel;
    ul.style.font = getComputedStyle(sel).font;
    ul.style.minWidth = r.width + 'px';
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      if (o.disabled) li.className = 'is-disabled';
      if (i === sel.selectedIndex) li.className += ' is-selected';
      fill(li, o.text);
      (function (idx, opt) {
        li.addEventListener('click', function () {
          if (opt.disabled) return;
          closeList();
          if (sel.selectedIndex !== idx) {
            sel.selectedIndex = idx;
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      })(i, o);
      ul.appendChild(li);
    }
    document.body.appendChild(ul);
    var top = r.bottom + window.scrollY + 2;
    // Not enough room below: open upward.
    if (r.bottom + ul.offsetHeight + 4 > window.innerHeight && r.top > ul.offsetHeight + 4) {
      top = r.top + window.scrollY - ul.offsetHeight - 2;
    }
    var left = r.left + window.scrollX + (r.width - ul.offsetWidth) / 2;
    left = Math.max(window.scrollX + 4, Math.min(left, window.scrollX + document.documentElement.clientWidth - ul.offsetWidth - 4));
    ul.style.top = top + 'px';
    ul.style.left = left + 'px';
    openList = ul;
    setTimeout(function () {
      document.addEventListener('pointerdown', outside, true);
      document.addEventListener('keydown', onKey, true);
      window.addEventListener('scroll', closeList, true);
      window.addEventListener('resize', closeList);
    }, 0);
  }

  function render(sel) {
    var wrap = sel.parentNode;
    var ov = wrap.querySelector('.ud-sel__txt');
    var o = sel.options[sel.selectedIndex];
    var cs = getComputedStyle(sel);
    // Hidden card (closed tab, offscreen slide): no box yet, cover the wrapper until the next pass.
    var shown = sel.offsetWidth > 0;
    ov.style.top = shown ? sel.offsetTop + 'px' : '0';
    ov.style.left = shown ? sel.offsetLeft + 'px' : '0';
    ov.style.width = shown ? sel.offsetWidth + 'px' : '100%';
    ov.style.height = shown ? sel.offsetHeight + 'px' : '100%';
    ov.style.padding = '0 ' + cs.paddingRight + ' 0 ' + cs.paddingLeft;
    ov.style.font = cs.font;
    ov.textContent = '';
    fill(ov, o ? o.text : '');
  }

  function wrap(sel) {
    sel.setAttribute('data-ud-sel', '');
    var w = document.createElement('span');
    w.className = 'ud-sel';
    sel.parentNode.insertBefore(w, sel);
    w.appendChild(sel);
    var ov = document.createElement('span');
    ov.className = 'ud-sel__txt';
    ov.setAttribute('aria-hidden', 'true');
    w.appendChild(ov);
    sel.addEventListener('change', function () { render(sel); });
    w.addEventListener('pointerenter', function () { render(sel); });
    sel.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || sel.disabled || (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents)) return;
      e.preventDefault();
      sel.focus();
      if (openList && openList._sel === sel) closeList(); else showList(sel);
    });
  }

  function scan() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      var sel = list[i];
      if (!sel.hasAttribute('data-ud-sel')) wrap(sel);
      if (sel.parentNode.classList.contains('ud-sel')) render(sel);
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function start() {
    scan();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('.ud-sel__txt')) continue;
        queue();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
